import { connect } from 'react-redux';
import { getProfile } from 'edrolo/domains/profile';
import QuestionSetResultsGridPage from './QuestionSetResultsGridPage';
import * as examSelectors from '../../data/selectors';
import { loadExam } from '../../data/actions';

const mapStateToProps = (state, { examId }) => {
  const profile = getProfile(state);

  return {
    examId,
    exam: examSelectors.getExam(state, examId),
    flatQuestions: examSelectors.getFlatQuestions(state, examId),
    examStatus: examSelectors.getExamLoadingStatus(state, examId),
    isStaff: profile.get('is_staff') || false,
  };
};

const mergeDispatchToProps = (dispatch) => ({
  loadExam: (examId) => dispatch(loadExam.signal(examId)),
});

export default connect(
  mapStateToProps,
  mergeDispatchToProps
)(QuestionSetResultsGridPage);
